module.exports = "<div id=\"map\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/maps/maps.component.html
// module id = ../../../../../src/app/maps/maps.component.html
// module chunks = main